import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  calculateTotals: {
    tong_tien: number;
    thue: number;
    tong_ck: number;
    tong_thanh_toan: number;
  };
  ty_gia?: number;
}

export function BottomBar({ calculateTotals, ty_gia = 1 }: BottomBarProps) {
  const { thue, tong_ck, tong_tien } = calculateTotals;

  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[260px]',
      fields: [
        { name: 't_tien_nt2', label: 'Tổng tiền', value: tong_tien, inputClassName: 'text-right font-medium' },
        {
          name: 't_tien2',
          label: 'Quy đổi',
          value: tong_tien * ty_gia,
          inputClassName: 'text-right font-medium',
          hidden: ty_gia === 1
        }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        { name: 't_thue_nt', label: 'Tổng thuế', value: thue, inputClassName: 'text-right font-medium' },
        {
          name: 't_thue',
          label: 'Quy đổi',
          value: thue * ty_gia,
          inputClassName: 'text-right font-medium',
          hidden: ty_gia === 1
        }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        { name: 't_ck_nt', label: 'Tổng chiết khấu', value: tong_ck, inputClassName: 'text-right font-medium' },
        {
          name: 't_ck',
          label: 'Quy đổi',
          value: tong_ck * ty_gia,
          inputClassName: 'text-right font-medium',
          hidden: ty_gia === 1
        }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        {
          name: 't_tt_nt',
          label: 'Tổng thanh toán',
          value: tong_tien + thue,
          inputClassName: 'text-right font-medium'
        },
        {
          name: 't_tt',
          label: 'Quy đổi',
          value: (tong_tien + thue) * ty_gia,
          inputClassName: 'text-right font-medium',
          hidden: ty_gia === 1
        }
      ]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}

export default BottomBar;
